import { VerifiedUsersPostsPage } from "./VerifiedUsersPostsPage";

export default VerifiedUsersPostsPage;
